// extracted by mini-css-extract-plugin
export default {"badge":"badge_badge__CQDm7","badge--approved":"badge_badge--approved__GZzNx","badge--declined":"badge_badge--declined__ii6km","badge--reported":"badge_badge--reported__TFauG"};